/*
deviceConfig.js
Copyright © 2026 Xerox Corporation. All Rights Reserved.

Copyright protection claimed includes all forms and matters of copyrightable material
and information now allowed by statutory or judicial law or hereinafter granted,
including without limitation, material generated from the software programs which
are displayed on the screen such as icons, screen display looks, etc.
*/

import axios from "axios"
import { xrxDeviceConfigGetDeviceInfoRequest } from "../modular-xerox-js-library/xrxjslib.module"
import { axiosConfigForDevice, deviceApiUrl } from "./eipClient"

const deviceInfoUrl = deviceApiUrl + '/webservices/office/device_configuration/1'

export const getDeviceInfo = () => axios.post(deviceInfoUrl, xrxDeviceConfigGetDeviceInfoRequest(), axiosConfigForDevice()).then(r => r.data)